"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridHelper = exports.Grid = exports.GridContext = void 0;
var react_1 = __importStar(require("react"));
var system_1 = require("../system");
var utils_1 = require("../utils");
var Box_1 = require("./Box");
function calcWidth(columns, k, _a) {
    var minContentWidth = _a.minContentWidth, maxContentWidth = _a.maxContentWidth, maxColumns = _a.columns, spaceUnit = _a.spaceUnit;
    var minColumnWidth = (minContentWidth - spaceUnit) / maxColumns;
    var maxColumnWidth = (maxContentWidth - spaceUnit) / maxColumns;
    var percents = (columns / maxColumns / k) * 100;
    return {
        minWidth: minColumnWidth * columns,
        maxWidth: maxColumnWidth * columns,
        width: "".concat(percents, "%"),
    };
}
function calcSpacingUnit(theme, type, spacing) {
    return spacing
        ? Number((0, utils_1.calcSpace)(spacing).replace('px', '')) / 2
        : theme.schemes.spacing[type].spaceUnit / 2;
}
var useStyles = (0, system_1.makeStyles)(function (theme) { return ({
    base: function (_a) {
        var columns = _a.columns, _b = _a.context, type = _b.type, k = _b.k;
        // либо columns либо ширина по контенту
        if (!columns) {
            return {};
        }
        var scheme = theme.go.schemes.spacing[type];
        var _c = calcWidth(columns, k, scheme), minWidth = _c.minWidth, maxWidth = _c.maxWidth, width = _c.width;
        return {
            minWidth: minWidth,
            maxWidth: maxWidth,
            width: width,
        };
    },
    container: {
        '&$base': {
            boxSizing: 'content-box',
        },
    },
    columnSpacing: {
        // width: ({context: {type}}: StyleProps) =>
        //     `calc(100% + ${2 * calcSpacingUnit(theme.go, type)}px)`,
        marginLeft: function (_a) {
            var type = _a.context.type;
            return -calcSpacingUnit(theme.go, type);
        },
        marginRight: function (_a) {
            var type = _a.context.type;
            return -calcSpacingUnit(theme.go, type);
        },
        '& > *': {
            paddingLeft: function (_a) {
                var type = _a.context.type;
                return calcSpacingUnit(theme.go, type);
            },
            paddingRight: function (_a) {
                var type = _a.context.type;
                return calcSpacingUnit(theme.go, type);
            },
        },
    },
    customSpacing: {
        margin: function (_a) {
            var type = _a.context.type, spacing = _a.spacing;
            return -calcSpacingUnit(theme.go, type, spacing);
        },
        '& > *': {
            flexShrink: 0,
            padding: function (_a) {
                var type = _a.context.type, spacing = _a.spacing;
                return calcSpacingUnit(theme.go, type, spacing);
            },
        },
    },
}); });
exports.GridContext = react_1.default.createContext({
    type: 'spacingScheme15',
    k: 1,
    parentColumns: 15,
});
exports.Grid = react_1.default.forwardRef(function Grid(_a, ref) {
    var children = _a.children, className = _a.className, container = _a.container, columns = _a.columns, flex = _a.flex, spacing = _a.spacing, props = __rest(_a, ["children", "className", "container", "columns", "flex", "spacing"]);
    var prevContext = (0, react_1.useContext)(exports.GridContext);
    var type = prevContext.type, k = prevContext.k, parentColumns = prevContext.parentColumns;
    var context = (0, react_1.useMemo)(function () {
        return columns
            ? {
                type: type,
                // коэффициент который приводит масштаб вложенных гридов к верхнему уровню
                // как если бы мы брали % от самого первого контейнера
                k: k * (columns / parentColumns),
                parentColumns: columns,
            }
            : prevContext;
    }, [columns, k, parentColumns, prevContext, type]);
    var _b = useStyles({
        columns: columns,
        context: prevContext,
        spacing: spacing,
    }), base = _b.base, containerClass = _b.container, columnSpacing = _b.columnSpacing, customSpacing = _b.customSpacing;
    return (react_1.default.createElement(Box_1.Box, __assign({ ref: ref, className: (0, utils_1.cn)(base, container || spacing ? containerClass : undefined, container ? columnSpacing : spacing ? customSpacing : undefined, className) }, props, { display: container || flex ? 'flex' : 'block' }),
        react_1.default.createElement(exports.GridContext.Provider, { value: context }, children)));
});
var useGridHelperStyles = (0, system_1.makeStyles)(function (theme) { return ({
    grid: {
        position: 'absolute',
        height: '100%',
        width: 'auto',
        opacity: 0.25,
        pointerEvents: 'none',
        zIndex: 10000,
        left: 24,
        right: 24,
    },
    column: {
        backgroundColor: theme.go.schemes.colors.system.BgAttention,
        height: '100%',
    },
}); });
function GridHelper() {
    var _a = useGridHelperStyles(), grid = _a.grid, column = _a.column;
    var type = (0, react_1.useContext)(exports.GridContext).type;
    var spacing = (0, system_1.useTheme)().go.schemes.spacing;
    var columns = spacing[type].columns;
    return (react_1.default.createElement(exports.Grid, { columns: columns, className: grid, container: true }, Array.from({ length: columns }).map(function (v, i) { return (react_1.default.createElement(exports.Grid, { key: i, columns: 1 },
        react_1.default.createElement("div", { className: column }))); })));
}
exports.GridHelper = GridHelper;
